// TalentNoteService.js
import api from "../../../api/api";
import { ENDPOINTS } from "../../../api/endpoints";
/**
 * Fetch all talent notes and return a map keyed by talentId.
 */
export const fetchTalentNotes = async ({ talentId, directorId }) => {
  try {
    const res = await api.get(
      ENDPOINTS.getTalentNotes(talentId, directorId)
    );

    const notes = res.data?.data || [];

    return notes.length
      ? {
          text: notes[0].noteText,
          noteId: notes[0].noteId,
        }
      : null;
  } catch (error) {
    console.error("Error fetching notes:", error);
    return null;
  }
};

/**
 * Save or update a talent note for a specific director and talent.
 */
export const saveTalentNote = async ({ talentId, noteText, directorId, noteId = 0 }) => {
  const payload = {
    noteId,
    talentId,
    directorId,
    noteText,
    createdAt: new Date().toISOString(),
  };

  try {
    const res = await api.post(ENDPOINTS.addOrUpdateTalentNote(), payload);
    return res.data;
  } catch (error) {
    console.error("Error saving note:", error);
    return null;
  }
};

/**
 * Move a talent between director lists (e.g., Callback → Shortlist → Selected).
 */
export const moveTalentToList = async ({ userId, roleId, currentList, targetList }) => {
  const payload = { userId, roleId, currentList, targetList };

  try {
    const res = await api.post(ENDPOINTS.updateUserList(), payload);
    return res.data;
  } catch (error) {
    console.error("Error moving talent:", error);
    return null;
  }
};

/**
 * Update a talent's favorite status for a specific client.
 */
export const updateFavoriteStatus = async ({ clientId, talentId, Fave }) => {
  const formData = new FormData();
  formData.append("clientId", clientId);
  formData.append("talentId", talentId);
  formData.append("Fave", Fave ? "true" : "false");

  try {
    const res = await api.post(ENDPOINTS.addOrUpdateFave(), formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.error("Error updating favorite:", error);
    return null;
  }
};
